<template>
  <div>
    <div v-if="!rollingBookingRule">
      <v-card elevation="0" class="no-base-rule text-center py-10">
        <h2 v-html="$t('page-rules.manage.section-base-rules-setup.title')" class="mb-2"></h2>
        <p v-html="$t('page-rules.manage.section-base-rules-setup.intro')" class="grey--text text--darken-2"></p>
        <v-btn v-html="$t('page-rules.manage.section-base-rules-setup.button')" :to="{ name: 'place-rules-base-create' }" large color="primary"></v-btn>
      </v-card>
    </div>
    <div v-else>
      <v-alert v-html="$t('page-rules.manage.section-base-rules.finalise-warning')" outlined type="warning" text clear v-if="rollingBookingRule.active === false" class="mb-8"></v-alert>
      <rolling :rollingBookingRule="rollingBookingRule" />
      <seasonal :place="place" :seasonalBookingRules="seasonalBookingRules" />
      <historical-seasonal :place="place" :seasonalBookingRules="historicalSeasonalBookingRules" />
    </div>
    <bottom-navigation class="mt-12" :forward="(currentUserHasRole('Administrator') || currentUserHasRole('Membership')) ? { title: $t('global-terms.rates'), to: { name: 'place-rates-manage' } } : null"></bottom-navigation>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { useBookingRuleStore, useUserStore } from '@/stores'
import Rolling from './Rolling.vue'
import Seasonal from './Seasonal.vue'
import HistoricalSeasonal from './HistoricalSeasonal.vue'
import BottomNavigation from '@/components/layout/BottomNavigation'

export default {
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUserHasRole']),
    ...mapState(useBookingRuleStore, {
      bookingRuleFindById: 'findById',
      seasonalBookingRulesFindByIdsCurrent: 'findByIdsCurrent',
      seasonalBookingRulesFindByIdsHistoric: 'findByIdsHistoric',
    }),
    rollingBookingRule () {
      return this.bookingRuleFindById(this.place.rollingBookingRule)
    },
    seasonalBookingRules () {
      return this.seasonalBookingRulesFindByIdsCurrent(this.place.seasonalBookingRules)
    },
    historicalSeasonalBookingRules () {
      return this.seasonalBookingRulesFindByIdsHistoric(this.place.seasonalBookingRules)
    },
  },
  components: {
    Rolling,
    Seasonal,
    HistoricalSeasonal,
    BottomNavigation,
  },
}
</script>
<style lang="scss" scoped>
.v-card.no-base-rule {
  border: 1px solid grey;
}
.v-expansion-panel::v-deep .v-expansion-panel-header__icon {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
